module.exports = __webpack_public_path__ + "media/images/category/feature/coj_c/coj_c-2-b90408f9fc671f62b057e9e8ea5d7e31.jpg";